import {Button} from '@vector';
import styles from './PricingPanel.module.css';

/**
 * Pricing card for brands that sell to schools by quotation only (e.g. South Africa).
 *
 * Same card as `PricingPanel`, without its audience switch and live product prices: these brands have no
 * private subscriptions and no card products, so there is nothing to fetch and nothing to switch between.
 */
export default function QuotePanel({content}) {
    return (
        <div className={styles.card}>
            <div className={styles.head}>
                <h2 className={styles.heading}>{content.heading}</h2>
            </div>

            <p className={styles.hint}>{content.body}</p>

            <div className={styles.figure}>
                <p className={styles.price}>{content.schoolPrice}</p>
                <p className={styles.priceNote}>{content.schoolNote}</p>
            </div>

            <div className={styles.footer}>
                <Button surface="base" size="large" href={content.action.href}>
                    {content.action.label}
                </Button>
                <p className={styles.hint}>{content.quoteNote}</p>
            </div>
        </div>
    );
}
